import "./AcademicPage.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const academicData  = [
  {
    title: "FOUNDATIONAL",
    subtitle: "CLASSES 1-2",
    items: [
      "Pre-school shapes work sheets",
      "Number and pre-math work sheets",
      "Pre-school Concepts work sheets",
      "Pre-school Colouring work sheets",
      "Alphabet work sheets",
      "Activity work sheets",
    ],
  },
  {
    title: "PREPARATORY",
    subtitle: "CLASS 3-4-5",
    items: [
      "Alphabet activities",
      "Mathematics",
      "Shapes games",
      "Colourful activities",
      "Basic Concepts",
      "Vocabulary",
    ],
  },
  {
    title: "MIDDLE STAGE",
    subtitle: "CLASSES 6-7-8",
    items: [
      "Count, Colour and Think",
      "Times Tables",
      "Number Detective",
      "Secret Code",
      "Number Patterns",
    ],
  },
  {
    title: "SECONDARY",
    subtitle: "CLASS 9-10-11-12",
    items: [
      "Word World",
      "Compound Words",
      "Rhyming Fun",
      "Alphabetical Order",
      "Educational chart",
    ],
  },
];

export default function AcademicPage({ selectedStage }) {
  const visibleSections = selectedStage
    ? academicData.filter((section) => section.title === selectedStage)
    : academicData;

  return (
    <div className={`allWrapper ${selectedStage ? "singleStageWrapper" : ""}`}>
      {visibleSections.map((section, index) => (
        <div className="allColumn" key={section.title}>
          <div className={`allHeading ${index === 0 ? "activeHeading" : ""}`}>
            <span className="headingTitle">{section.title}</span>
            <span className="headingSubTitle">{section.subtitle}</span>
          </div>

          <ul>
            {section.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <div className="circleArrow">
            <KeyboardArrowDownIcon />
          </div>
        </div>
      ))}
    </div>
  );
}
